import { FormEvent, useCallback, useState } from 'react';
import { useNavigate } from 'react-router';
import { faArrowLeft } from '@fortawesome/pro-solid-svg-icons';
import { useClientContext } from 'client/context';
import { UserCreate } from 'client/voladeum/users/types';
import { setToken } from 'ducks/user/slices';
import { Button } from 'framework/button';
import { Icon } from 'framework/Icon';
import { Input } from 'framework/Input';
import { PUBLIC } from 'router/routes';
import { useAppDispatch } from 'store/hooks';

import { GoogleButton } from 'components/google/GoogleButton';

import { user_create_default } from './defaults';

import cn from './CreateAccountPage.module.scss';
const { PUBLIC_URL } = process.env;

export default () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const [form, setForm] = useState<UserCreate>({ ...user_create_default });
  const { Voladeum, handleError } = useClientContext();

  const onChange = useCallback(
    (user: Partial<UserCreate>) => setForm((prev) => ({ ...prev, ...user })),
    []
  );

  const onSubmit = useCallback(
    async (e: FormEvent<HTMLFormElement>) => {
      try {
        e.preventDefault();
        const payload: UserCreate = {
          first_name: form.first_name,
          last_name: form.last_name,
          email: form.email,
          user_name: form.user_name,
          password: form.password,
        };
        const res = await Voladeum.users.create(payload);
        dispatch(setToken({ token: res.data }));
      } catch (err) {
        handleError(err);
      }
    },
    [
      form.first_name,
      form.last_name,
      form.email,
      form.user_name,
      form.password,
      Voladeum.users,
      dispatch,
      handleError,
    ]
  );

  return (
    <div className={cn.page}>
      <div className={cn.container}>
        <form className={cn.form} onSubmit={onSubmit}>
          <div className={cn.logo}>
            <img src={`${PUBLIC_URL}/voladeum/voladeum-vertical.png`} alt="Voladeum" />
          </div>
          <div className={cn.row}>
            <Input
              height="34px"
              onChange={({ value }) => onChange({ first_name: value })}
              value={form.first_name}
              placeholder="First Name"
            />
            <Input
              height="34px"
              onChange={({ value }) => onChange({ last_name: value })}
              value={form.last_name}
              placeholder="Last Name"
            />
          </div>
          <Input
            height="34px"
            onChange={({ value }) => onChange({ email: value })}
            value={form.email}
            placeholder="Email Address"
          />
          <Input
            height="34px"
            onChange={({ value }) => onChange({ user_name: value })}
            value={form.user_name}
            placeholder="User Name"
          />
          <Input
            height="34px"
            onChange={({ value }) => onChange({ password: value })}
            value={form.password}
            type="password"
            placeholder="Password"
          />
          <Button type="submit" width="100%" height="36px" shadow>
            Create account
          </Button>
          <div className={cn.row}>
            <div className={cn.break} />
            <p className={cn.text}>OR</p>
            <div className={cn.break} />
          </div>
          <GoogleButton />
        </form>
        <a className={cn.back} onClick={() => navigate(PUBLIC.LOGIN.path)}>
          <Icon icon={faArrowLeft} size="14px" width="30px" />
          Sign in
        </a>
      </div>
    </div>
  );
};
